import { Component } from '@angular/core';
import { COLUMNS_HEADER_CLEANINGS_ADMIN } from '../../core/constants/tables.constants';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { CleaningsService } from '../../core/services/cleanings.service';

@Component({
  selector: 'app-cleaning',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, FormsModule, ReactiveFormsModule, SpinnerComponent, GenericTableComponent],
  templateUrl: './cleaning.component.html',
  styleUrl: './cleaning.component.scss'
})
export class CleaningComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_CLEANINGS_ADMIN;

  cleanings: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;

  faSpinner = faSpinner;

  form: FormGroup = this.formBuilder.group({
    id: [, Validators.required],
    duration: [, Validators.required],
    fecha_inicio_blender: [''],
    fecha_fin_blender: [''],
    name: [''],
    active: []
  });

  constructor(
    private cleaningsSvc: CleaningsService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  async ngOnInit() {
    await this.getCleanings();
    this.isLoading = false;
  }

  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getCleanings();
        this.isModalActive = false;
        this.isLoading = false;

        if (this.isCreating) {
          this.toastr.success(`La limpieza ${this.form.value.id} ha sido creada correctamente`);
        } else {
          this.toastr.success(`La limpieza ${this.form.value.id} ha sido actualizada correctamente`);
        }
        this.form.reset();
      },
      error: () => {
        this.isLoading = false;
      }
    };


    if (this.form.valid) {
      if (this.isCreating) {
        this.form.value.fecha_inicio_blender = new Date(this.form.value.fecha_inicio_blender).toISOString();
        this.form.value.fecha_fin_blender = new Date(this.form.value.fecha_fin_blender).toISOString();
        this.cleaningsSvc.createCleaning(this.form.value).subscribe(responseAction);
      } else {
        this.cleaningsSvc.updateCleaning(this.form.value).subscribe(responseAction);
      }
    }
  }

  async getCleanings() {
    this.cleaningsSvc.getCleanings().subscribe((res: any) => {
      this.cleanings = res;
    });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      item.fecha_inicio_blender = this.formatISODate(item.fecha_inicio_blender);
      item.fecha_fin_blender = this.formatISODate(item.fecha_fin_blender);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.cleaningsSvc.deleteCleaning(item.id).subscribe({
      next: () => {
        this.getCleanings();
        this.isLoading = false;
        this.toastr.success(`La limpieza ${item.id} ha sido eliminada correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    });
  }

  formatISODate(dateISO: any): any {
    const date = new Date(dateISO);
    return `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}T${this.addZero(date.getHours())}:${this.addZero(date.getMinutes())}`;
  }

  addZero(number: any) {
    if (number < 10) {
      return `0${number}`;
    } else {
      return number;
    }
     
  }

}
